import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ContentErrorUi from "../../../components/errorBoundary/contentErrorUi";
import PageHeader from "./headers/pageHeader";
import { Layout } from "antd";
import { useAppSelector } from "../../../hooks/reduxHooks";

interface ProtectedLayoutStoreInterface {
  children?: any;
}

const { Content } = Layout;

const ProtectedLayoutStore: React.FC<ProtectedLayoutStoreInterface> = (
  props
) => {
  const state: any = useAppSelector((state) => state.profile);
  const { is_subscription_valid } = state;
  const data = state?.userData;
  const hasStore = data?.has_store;
  const surveryStatus =
    data?.survey_status === "responded" || data?.survey_status === "answered";
  const { children } = props;
  const location = useLocation();
  // const state: any = useAppSelector((state) => state.profile?.userData);
  // const hasStore = state?.has_store;
  const surveyStatus = state?.survey_status;
  const isAccessStore = location.pathname.includes("/store" || "/store/");

  const navigate = useNavigate();

  const alrounderToken = localStorage.getItem("alrounderToken");

  useEffect(() => {
    console.log("ProtectedLayoutStore useEffect triggered");
    if (!alrounderToken) {
      navigate("/login");
      return; // Stop further execution once redirected to login
    }
    if (!is_subscription_valid) {
      navigate("/store/subscription");
      return;
    }
    // if (hasStore && surveryStatus) {
    //   navigate("/store");
    // } else if (!hasStore && surveyStatus === "paid" && isAccessStore) {
    //   navigate("/processing");
    // } else {
    //   navigate("/processing");
    // }
  }, [alrounderToken, navigate]);

  // useEffect(() => {
  //   if (!alrounderToken) {
  //     navigate("/login");
  //   }

  //   if (hasStore && surveryStatus) {
  //     navigate("/store");
  //   } else {
  //     navigate("/processing");
  //   }
  // }, []);

  // if (!hasStore && surveyStatus === "paid" && isAccessStore) {
  //   navigate("/processing");
  // }
  return (
    <Layout id="app-layout">
      <ErrorBoundary FallbackComponent={ContentErrorUi} onReset={() => {}}>
        <PageHeader />
      </ErrorBoundary>
      <Layout className="main-app-layout">
        <ErrorBoundary FallbackComponent={ContentErrorUi} onReset={() => {}}>
          <Content>
            <div className="main-content-wrapper">{children}</div>
          </Content>
        </ErrorBoundary>
      </Layout>
    </Layout>
  );
};

export default ProtectedLayoutStore;
